<template>
  <div class="device-location-container">
    <DeviceGroupElement
      v-for="deviceGroup in getDeviceGroupsByFloor(selectedFloorLevel)"
      :key="'deviceGroup_' + deviceGroup.id"
      :device="device"
      :device-group="deviceGroup"
      :installation-point="installationPoint"
      :arm-installation-points="armInstallationPoints"
      :update-arm-installation-points="updateArmInstallationPoints"
    />
  </div>
</template>
<script setup lang="ts">
import DeviceGroupElement from '@/components/Forms/DeviceFormComponents/AdvancedRegistraionMeter/DeviceGroupElement.vue';
import { DeviceGroup } from '@/components/Forms/DeviceFormComponents/AdvancedRegistraionMeter/DeviceGroup.vue';
import { InstallationPoint } from '@/models/installationPoint/InstallationPoint';
import { DeviceClasses } from '@/models/devices/Device';

const props = defineProps<{
  device: DeviceClasses;
  deviceGroups: DeviceGroup[];
  selectedFloorLevel: string;
  installationPoint: InstallationPoint;
  armInstallationPoints?: InstallationPoint[];
  updateArmInstallationPoints?: (
    newArmInstallationPoints: InstallationPoint[]
  ) => void;
}>();

const getDeviceGroupsByFloor = (floor: string) => {
  return props.deviceGroups.filter((deviceGroup) => {
    return deviceGroup.name.includes(floor);
  });
};
</script>

<style>
.device-location-container input {
  transform: scale(1.3);
}
.device-location-container input:hover {
  cursor: pointer;
}

.device-location-container label {
  display: unset;
  margin-left: 15px;

  > span {
    font-size: 18px;
  }
}
</style>
